/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Separator } from '@/components/ui/separator'
import React, { useEffect } from 'react'
import {
    Select,
    SelectContent,
    SelectGroup,
    SelectItem,
    SelectLabel,
    SelectTrigger,
    SelectValue,
  } from "@/components/ui/select"
  import { Progress } from "@/components/ui/progress"
import Alert from '../common/Alert'
import CloseButton from '../common/CloseButton'
import { makeRequest } from '@/utils/axiosInterceptor'
import { useQueryClient } from "@tanstack/react-query";
import { useGetFetchQuery } from '@/hooks/query-client'
import { Checkbox } from '@/components/ui/checkbox'
import ResetPasswordModal from './ResetPasswordModal'

export default function UserEditForm({selected, setSelected}) {

    const hospitalData = useGetFetchQuery(['hospital'])
    const queryClient = useQueryClient();
    const [editActive, setEditActive] = React.useState(false)
    const [isSubmitting, setIsSubmitting] = React.useState(false)

    const [deleteAlert, setDeleteAlert] = React.useState(false)
    const [recoverAlert, setRecoverAlert] = React.useState(false)

    const [blockAlert, setBlockAlert] = React.useState(false)
    const [unBlockAlert, setUnBlockAlert] = React.useState(false)
    const [updateAlert, setUpdateAlert] = React.useState(false)
    const [resetPasswordDialog, setResetPasswordDialog] = React.useState(false)


    const [currData, setCurrData] = React.useState(selected)
    const isModified = JSON.stringify(selected) !== JSON.stringify(currData)


    useEffect(() => {
        setEditActive(false)
        setCurrData(selected)
    }, [selected])


    const updateUser = async () => {
        try {
            setIsSubmitting(true)
            const accessRoute = `/users/update/${selected.id}`
            console.log(currData)
            const { data: userData } = await makeRequest("POST", accessRoute, currData);
            queryClient.invalidateQueries(['users'])
            setSelected(userData)
            setUpdateAlert(false)
            setEditActive(false)
        } catch (error) {
            console.error("Error fetching instances:", error);
        } finally {
            setIsSubmitting(false)
        }
    }

    const recoverDeleteUser = async () => {
        try {
            let apiRoute = ''
            if (selected.is_deleted === true) {
                console.log('recovering')
                apiRoute = `/users/recover/${selected.id}`
            } else if (selected.is_deleted === false) {
                console.log('deleting')
                apiRoute = `/users/delete/${selected.id}`
            }
            const res = await makeRequest('GET', apiRoute, '')
            if (res?.status === 200) {
                queryClient.invalidateQueries(['users'])
                setSelected(res.data)
                setDeleteAlert(false)
                setRecoverAlert(false)
            }
            console.log(res)
        } catch (err) {
            console.log(err)
        }
    }


  return (
    <div style={{width:'100%'}}>
            <div style={{display:'flex',justifyContent:'space-between', flexDirection:'row', alignItems:'center'}}>
                <div>
                    <span style={{fontWeight:'bold'}}>Editing User : </span>{selected.username} 
                </div>
                <div style={{display:'flex', gap:'0.5vw', alignItems:'center'}}>
                    {
                        editActive === true ? 
                        <Button onClick={() => setUpdateAlert(true)} disabled={isSubmitting}>Save Changes</Button>
                        :
                        <Button disabled={editActive} onClick={() => setEditActive(!editActive)}>Edit</Button>
                    }
    
                    {
                        selected.is_deleted === false ?
                        <Button onClick={() => setDeleteAlert(true)} className='ml-[0.5vw]' variant="destructive">Delete</Button>
                        :
                        <Button onClick={() => setRecoverAlert(true)} className='ml-[0.5vw]' >Recover</Button>
                    }
                    
                    <CloseButton 
                        onClose={() => setSelected(null)}
                        isModified={isModified}
                        isSubmitting={isSubmitting}
                    />
                </div>
                
            </div>
            <Separator className="mt-[1vh]"/>
            <div style={{display:'flex',justifyContent:'space-between', flexDirection:'row', width: '100%'}}>
                <div className=' p-2' style={{width: '50%', height: '75vh', display:'flex', flexDirection:'column'}}>
                    <h2 style={{fontWeight:'bold'}} className='text-lg'>User Details</h2>
                    <Separator className="mt-[1vh]"/>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Username </h5>
                        <Input onChange={(e) => setCurrData({...currData, username: e.target.value})} 
                            disabled={!editActive} value={currData.username} 
                            className='mt-[1vh]' 
                        />
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Name (As on report)</h5>
                        <Input 
                            onChange={(e) => setCurrData({...currData, name: e.target.value})} 
                            disabled={!editActive} value={currData.name} className='mt-[1vh]' 
                        />
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>User group</h5>
                        <div className='mt-[1vh]'>
                            <Select 
                                onValueChange={(value) => setCurrData({...currData, user_group: value})} 
                                disabled={!editActive} value={currData.user_group}
                            >
                                <SelectTrigger>
                                    <SelectValue placeholder="User Type" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                    <SelectLabel>Institution Type</SelectLabel>
                                    <SelectItem value="Root">Root</SelectItem>
                                    <SelectItem value="Admin">Admin</SelectItem>
                                    <SelectItem value="Self">Self</SelectItem>
                                    <SelectItem value="AllStudy">All Study</SelectItem>
                                    <SelectItem value="Reporter">Reporter</SelectItem>
                                    <SelectItem value="AiEvaluator">AiEvaluator</SelectItem>
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Email</h5>
                        <Input 
                            onChange={(e) => setCurrData({...currData, email: e.target.value})} 
                            disabled={!editActive} value={currData.email} className='mt-[1vh]' 
                        />
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Designation</h5>
                        <Input 
                            onChange={(e) => setCurrData({...currData, designation: e.target.value})} 
                            disabled={!editActive} value={currData.designation} className='mt-[1vh]' 
                        />
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Account Deleted ?</h5>
                        <h5 className='text-sm'>{selected.is_deleted ? "Yes" : "No"}</h5>
                    </div>
                </div>
                <Separator orientation="vertical" className="mt-[1vh] h-[73vh]"/>
                <div className=' p-2' style={{width: '50%', height: '75vh', display:'flex', flexDirection:'column'}}>
                    {/* <h2 style={{fontWeight:'bold'}} className='text-lg'>Subscription Details</h2>
                    <Separator className="mt-[1vh]"/>
                    <div className='mt-[2vh]' style={{width:'100%', display: 'flex', flexDirection:'row'}}>
                        <div style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>Space Allocated</h5>
                            <Input onChange={(e) => setCurrData({...currData, space_allocated: e.target.value})}  disabled={!editActive} type='number' value={currData.space_allocated} className='mt-[1vh]' />
                        </div>
                        <div className='ml-[0.5vw]' style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>Users Allocated</h5>
                            <Input 
                                onChange={(e) => setCurrData({...currData, allowed_users: e.target.value})} 
                                disabled={!editActive} type='number' value={currData.allowed_users} className='mt-[1vh]' 
                            />
                        </div>
                    </div> */}
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Hospital/Clinic</h5>
                        <div className='mt-[1vh]'>
                            <Select 
                                onValueChange={(value) => setCurrData({...currData, hospital_clinic_id: value})} 
                                disabled={!editActive} value={currData.hospital_clinic_id}
                            >
                                <SelectTrigger>
                                    <SelectValue placeholder="Hospital" />
                                </SelectTrigger>
                                <SelectContent>
                                    <SelectGroup>
                                    <SelectLabel>Institution Type</SelectLabel>
                                    {
                                        hospitalData !== undefined ? hospitalData.map((item) => {
                                            return (
                                                <SelectItem value={item.id}>{item.name}</SelectItem>
                                            )
                                        })
                                        :
                                        null
                                    }
                                    {/* <SelectItem value="Root">Root</SelectItem>
                                    <SelectItem value="Admin">Admin</SelectItem>
                                    <SelectItem value="Self">Self</SelectItem>
                                    <SelectItem value="AllStudy">All Study</SelectItem>
                                    <SelectItem value="Reporter">Reporter</SelectItem> */}
                                    </SelectGroup>
                                </SelectContent>
                            </Select>
                        </div>
                    </div>
                    <div style={{display:'flex', flexDirection: 'row', width:'100%', justifyContent:'flex-start', alignItems:'flex-start'}} className='mt-[2vh]'>
                        {/* <div style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>User Blocked</h5>
                            <h5 className='text-sm'>{selected.subscription_active ? "Yes" : "No"}</h5>
                        </div>
                        <div style={{width:'50%', display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>
                            {
                                selected.is_blocked ? 
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setBlockAlert(true)} variant="destructive">Block</Button>:
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setUnBlockAlert(true)}>Unblock</Button>
                            }
                        </div> */}
                        <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.is_blocked} onCheckedChange={(val) => setCurrData({...currData, is_blocked: val})} 
                                id="Atlectasis" 
                            />
                                <label
                                    htmlFor="Atlectasis"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    Is Blocked ?
                                </label>
                        </div>
                        
                    </div>
                    <div style={{display:'flex', flexDirection: 'row', width:'100%', justifyContent:'flex-start', alignItems:'flex-start'}} className='mt-[2vh]'>
                        {/* <div style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>MFA Enabled</h5>
                            <h5 className='text-sm'>{selected.mfa_enabled ? "Yes" : "No"}</h5>
                        </div>
                        <div style={{width:'50%', display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>
                            {
                                selected.mfa_enabled ? 
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setBlockAlert(true)} variant="destructive">Disable</Button>:
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setUnBlockAlert(true)}>Enable</Button>
                            }
                        </div> */}
                         <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.mfa_enabled} onCheckedChange={(val) => setCurrData({...currData, mfa_enabled: val})} 
                                id="Atlectasis" 
                            />
                                <label
                                    htmlFor="Atlectasis"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    MFA Enabled ?
                                </label>
                        </div>
                        
                    </div>
                    <div style={{display:'flex', flexDirection: 'row', width:'100%', justifyContent:'flex-start', alignItems:'flex-start'}} className='mt-[2vh]'>
                        {/* <div style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>PII Allowed</h5>
                            <h5 className='text-sm'>{selected.pii_allowed ? "Yes" : "No"}</h5>
                        </div>
                        <div style={{width:'50%', display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>
                            {
                                selected.pii_allowed ? 
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setBlockAlert(true)} variant="destructive">Disable</Button>:
                                <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setUnBlockAlert(true)}>Enable</Button>
                            }
                        </div> */}
                         <div className="flex items-center space-x-2">
                            <Checkbox disabled={!editActive} checked={currData.pii_allowed} onCheckedChange={(val) => setCurrData({...currData, pii_allowed: val})} 
                                id="Atlectasis" 
                            />
                                <label
                                    htmlFor="Atlectasis"
                                    className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                                >
                                    PII Allowed ?
                                </label>
                        </div>
                    </div>

                    <div style={{display:'flex', flexDirection: 'row', width:'100%', justifyContent:'flex-start', alignItems:'flex-start'}} className='mt-[2vh]'>
                        <div style={{width:'50%'}}>
                            <h5 style={{fontWeight:'bold'}} className='text-sm'>Password</h5>
                        </div>
                        <div style={{width:'50%', display:'flex', justifyContent:'flex-end', alignItems:'flex-start'}}>
                            <Button disabled={!editActive} className='text-xs h-[3.5vh]' onClick={() => setResetPasswordDialog(true)} variant="destructive">Reset</Button>
                        </div>
                    </div>
                    {/* <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Subscription Start Date</h5>
                        <Input disabled={!editActive} type='datetime-local'  value={currData.subscription_start} className='mt-[1vh]' />
                    </div>
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Subscription End Date</h5>
                        <Input disabled={!editActive} type='datetime-local' value={currData.subscription_end} className='mt-[1vh]' />
                    </div>
    
                    <h2 style={{fontWeight:'bold'}} className='text-lg mt-[2vh]'>Usage Details</h2>
                    <Separator className="mt-[1vh]"/>
    
                    <div className='mt-[2vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Current storage usage</h5>
                        <Progress className='mt-[1vh]' value={50} />
                        <span className='text-xs'>50/100 GB Used</span>
                    </div>
                    <div className='mt-[1vh]'>
                        <h5 style={{fontWeight:'bold'}} className='text-sm'>Total users created</h5>
                        <Progress className='mt-[1vh]' value={10} />
                        <span className='text-xs'>2/10 Users Created</span>
                    </div> */}
                </div>
            </div>
    
    
            <Alert
                open={deleteAlert}
                setOpen={setDeleteAlert}
                title="Delete User"
                description ="Are you sure you want to delete this user ?"
                action={recoverDeleteUser}
            />
    
            <Alert
                open={recoverAlert}
                setOpen={setRecoverAlert}
                title="Recover User"
                description ="Are you sure you want to recover this user ?"
                action={recoverDeleteUser}
            />
    
            <Alert
                open={updateAlert}
                setOpen={setUpdateAlert}
                title="Update user details"
                description ="Are you sure you want to make changes to this user ?"
                action={updateUser}
            />
    
            {/* <Alert
                open={deactivateAlert}
                setOpen={setDeactivateAlert}
                title="Deactivate Subscription"
                description ="Are you sure you want to deactivate the subscription for this hospital ?"
                action={deactivateSubscription}
            />
    
            <Alert
                open={activateAlert}
                setOpen={setActivateAlert}
                title="Activate Subscription"
                description ="Are you sure you want to activate the subscription for this hospital ?"
                action={ativateSubscription}
            /> */}
            <ResetPasswordModal 
                resetPasswordDialog={resetPasswordDialog}
                setResetPasswordDialog={setResetPasswordDialog}
                id={selected.id}
            />
        </div>
  )
}
